import { ConnectedProps } from './typings'
import { StoreData } from '@user/store/reducers/typings'
import { connect } from 'react-redux'

const mapStateToProps = (state: StoreData): ConnectedProps => ({
  loadingState: state.loadingState.loadingState,
})

export const stateDecorator = connect(mapStateToProps)
